// libraries
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import RoundedBox from '/react4xp/components/RoundedBox'
import Accordion, { AccordionList } from '/react4xp/components/Accordion'

// types
export interface AccordionsProps {
    className?: string
    isAnimated?: boolean
    title?: string
    color?: 'white' | 'green-light' | 'beige'
    accordions?: {
        id?: string
        title?: string
        content?: string
    }[]
    expandAllButton?: {
        expandLabel?: string
        collapseLabel?: string
    }
}

// css
import './index.scss'

export default function Accordions({
    className,
    isAnimated,
    title,
    color,
    accordions,
    expandAllButton
}: AccordionsProps) {
    return (
        <Section className={clsx(
            'accordions-component',
            className
        )}>
            <div
                className='container'
                data-stagger-up={isAnimated ? 'true' : 'false'}
            >
                {(title || (accordions && (accordions.length > 1))) && (
                    <RoundedBox
                        bgColor={color}
                        className='accordions-component__box'
                    >
                        <div className='row'>
                            <div className='col-lg-10 offset-lg-1 col-xl-6 offset-xl-3'>

                                {title && (
                                    <h2 className='h2 accordions-component__title'>
                                        {title}
                                    </h2>
                                )}

                                <AccordionList expandAllButton={expandAllButton}>
                                    <div className='accordions-component__accordions'>
                                        {accordions?.map((item, i) => (
                                            <Accordion
                                                key={i}
                                                anchorId={item.id}
                                                title={item.title}
                                                content={item.content}
                                                color={
                                                    color === 'white' || color === 'beige' ? 'green' :
                                                    color === 'green-light' ? 'beige' :
                                                    'green'
                                                }
                                            />
                                        ))}
                                    </div>
                                </AccordionList>

                            </div>
                        </div>
                    </RoundedBox>
                )}
            </div>
        </Section>
    )
}